import { Button, Input, Layout, PageHeader, Table } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { apiClient, apiErrorMessage, getApiBaseUrl } from '../../utils';
import { FileExcelOutlined, ReloadOutlined } from '@ant-design/icons';

export function PlmItemsJigsReport() {
  const { Content } = Layout;
  const history = useHistory();

  const [loading, setLoading] = useState(false);
  const [plmItemsJigs, setPlmItemsJigs] = useState<any[]>();

  const [tableCurrent, setTableCurrent] = useState(1);
  const [tablePageSize, setTablePageSize] = useState(10);
  const [tableTotal, setTableTotal] = useState(0);

  const [search, setSearch] = useState<string>();

  const onBackClick = () => {
    history.goBack();
  };

  const loadPlmItemsJigs = useCallback(() => {
    setLoading(true);
    let offset = (tableCurrent - 1) * tablePageSize;
    const queryParams = [`limit=${tablePageSize}`, `offset=${offset}`];
    if (search) {
      queryParams.push(`search=${search}`);
    }
    const queryParamsStr = queryParams.join('&');
    apiClient
      .get(`reports/plm-items-jigs?${queryParamsStr}`)
      .then((response: any) => {
        const responseData = response.data.rows as any[];

        if (!responseData || !responseData.length) {
          setPlmItemsJigs(undefined);
          setTableTotal(0);
          return;
        }

        setPlmItemsJigs(responseData);
        setTableTotal(response.data.count);
      })
      .catch((reason: any) => {
        apiErrorMessage(reason);
      })
      .finally(() => setLoading(false));
  }, [search, tableCurrent, tablePageSize]);

  useEffect(() => {
    loadPlmItemsJigs();
  }, [loadPlmItemsJigs]);

  const onRefreshClick = () => {
    loadPlmItemsJigs();
  };

  const onTableChange = (pagination: any) => {
    setTableCurrent(pagination.current);
    setTablePageSize(pagination.pageSize);
  };

  const onSearch = (input: string) => {
    input = input.trim();
    setSearch(input === '' ? undefined : input);
  };

  const onExcelExportClick = () => {
    const baseApiUrl = getApiBaseUrl() + '/api/';
    const url = `${baseApiUrl}reports/plm-items-jigs/export`;
    window.open(url, '_blank');
  };

  const tableColumns = [
    {
      title: 'Mastar Sınıflandırma Tipi',
      dataIndex: ['mastarSiniflandirmaTipi'],
      key: 'mastarSiniflandirmaTipi',
    },
    {
      title: 'Vida Profil',
      dataIndex: ['vidaProfil'],
      key: 'vidaProfil',
    },
    {
      title: 'Esas Ölçü Set Kontrol',
      dataIndex: ['esasOlcuSetKontrol'],
      key: 'esasOlcuSetKontrol',
    },
    {
      title: 'Standard',
      dataIndex: ['standard'],
      key: 'standard',
    },
    {
      title: 'Vida Tanımı (Esas Ölçü)',
      dataIndex: ['vidaTanimiEsasOlcu'],
      key: 'vidaTanimiEsasOlcu',
    },
    {
      title: 'Mastar Sınıf Tip Kod',
      dataIndex: ['mastarSinifTipKod'],
      key: 'mastarSinifTipKod',
    },
    {
      title: 'Go/NGo',
      dataIndex: ['goNgo'],
      key: 'goNgo',
    },
    {
      title: 'BP',
      dataIndex: ['bp'],
      key: 'bp',
    },
    {
      title: 'Plating Thickness',
      dataIndex: ['platingThickness'],
      key: 'platingThickness',
    },
    {
      title: 'Mastar Design',
      dataIndex: ['mastarDesign'],
      key: 'mastarDesign',
    },
    {
      title: 'LH (Yes/No)',
      dataIndex: ['lh'],
      key: 'lh',
    },
    {
      title: 'Handle #',
      dataIndex: ['handle'],
      key: 'handle',
    },
    {
      title: 'Mastar Standard Tanım (Go/NGo)',
      dataIndex: ['mastarStandardTanim'],
      key: 'mastarStandardTanim',
    },
    {
      title: 'VSRM Tanım',
      dataIndex: ['vsrmTanim'],
      key: 'vsrmTanim',
    },
    {
      title: 'Parça PLM No',
      dataIndex: ['parcaPlmNo'],
      key: 'parcaPlmNo',
    },
    {
      title: 'Revizyon',
      dataIndex: ['revizyon'],
      key: 'revizyon',
    },
  ];

  return (
    <>
      <PageHeader
        title="PLM Kalem - Mastar eşleştirmeleri"
        onBack={onBackClick}
        extra={[
          <Input.Search placeholder="Arama" allowClear={true} onSearch={onSearch} style={{ width: 200 }} />,
          <Button type="primary" icon={<FileExcelOutlined />} onClick={onExcelExportClick}>
            Excel'e aktar
          </Button>,
          <Button key="refresh" onClick={onRefreshClick} icon={<ReloadOutlined />}>
            Yenile
          </Button>,
        ]}
      />
      <Content>
        <Table
          columns={tableColumns}
          dataSource={plmItemsJigs}
          loading={loading}
          scroll={{ x: '100%' }}
          pagination={
            search
              ? false
              : {
                  current: tableCurrent,
                  total: tableTotal,
                  pageSize: tablePageSize,
                  pageSizeOptions: ['10', '25', '50', '100'],
                  position: ['bottomCenter'],
                  showTotal: (total, range) => `Toplam ${total} kayıt. ${range[0]}-${range[1]} arası gösteriliyor.`,
                  showSizeChanger: true,
                }
          }
          onChange={onTableChange}
        />
      </Content>
    </>
  );
}
